webpackJsonp([35783957827783],{

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Glenn.773dfefc.jpg";

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IndexImage.c0691d6e.jpg";

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(65);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _IndexImage = __webpack_require__(460);
	
	var _IndexImage2 = _interopRequireDefault(_IndexImage);
	
	var _Glenn = __webpack_require__(459);
	
	var _Glenn2 = _interopRequireDefault(_Glenn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hero = {
	    height: '50vh',
	    position: 'relative',
	    overflow: 'hidden',
	    marginTop: -80
	};
	
	var IndexImageCss = {
	    opacity: 0,
	    width: '100%',
	    height: '60%',
	    objectFit: 'cover',
	    objectPosition: 'center',
	    position: 'fixed',
	    zIndex: -10,
	    transition: 'all 1s ease-in-out'
	};
	
	var button = {
	    display: 'block',
	    padding: '20px 40px',
	    background: '#48e584',
	    color: 'white',
	    textDecoration: 'none',
	    boxShadow: '0px 7px 20px 0px #00000036'
	};
	
	var YouTubeIds = ['d0ZZbuNmFas', 'IzFNvcECyF0', 'Y_5MW25__1Y', '9SmUxbjOsr0', 'NVZOfVMOmxo', 'Exu6EB9uMpQ', 'nXFWFaigWeo', 'xeMqbFoiPLI'];
	
	var _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	            YouTube: null,
	            images: [_IndexImage2.default, 'https://s3.amazonaws.com/fishfin/Boats/photo%20(5).JPG', 'https://s3.amazonaws.com/fishfin/Cars%20&%20Bikes/DSC00899.JPG', 'https://s3.amazonaws.com/fishfin/Diving/PIC_0181.JPG', 'https://s3.amazonaws.com/fishfin/Hunting/pictures%201110.jpg', 'https://s3.amazonaws.com/fishfin/Keys%20Fishing/DSC00079.JPG'],
	            image: 0
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _class.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        this.interval = setInterval(function () {
	            var count = _this2.state.image + 1 >= _this2.state.images.length ? 0 : _this2.state.image + 1;
	            _this2.setState({ image: count });
	        }, 4500);
	    };
	
	    _class.prototype.componentWillUnmount = function componentWillUnmount() {
	        clearInterval(this.interval);
	    };
	
	    _class.prototype.render = function render() {
	        var _this3 = this;
	
	        return _react2.default.createElement('div', null);
	        return _react2.default.createElement(
	            'div',
	            null,
	            this.state.YouTube ? _react2.default.createElement(
	                'div',
	                { style: {
	                        position: 'fixed', left: 0, right: 0, bottom: 0, top: 0, backgroundColor: 'rgba(0,0,0,.3)', zIndex: 999,
	                        display: 'flex', justifyContent: 'center', flexDirection: 'column'
	                    }, onClick: function onClick() {
	                        return _this3.setState({ YouTube: null });
	                    } },
	                _react2.default.createElement('iframe', { style: { margin: '0 auto' }, width: '560', height: '315', src: 'https://www.youtube.com/embed/' + this.state.YouTube, frameborder: '0', allow: 'autoplay; encrypted-media', allowfullscreen: true })
	            ) : null,
	            _react2.default.createElement(
	                'div',
	                { style: hero },
	                this.state.images.map(function (image, index) {
	                    return _react2.default.createElement('img', { id: 'banner', src: image,
	                        style: _extends({}, IndexImageCss, {
	                            opacity: _this3.state.image === index ? 1 : 0
	                        }) });
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: { background: '#fff', visibility: 0 }, className: 'animated slideInUp' },
	                _react2.default.createElement(
	                    'div',
	                    { style: {
	                            margin: '0 auto',
	                            maxWidth: 600,
	                            padding: '1.45rem 1.0875rem'
	                        } },
	                    _react2.default.createElement('img', { src: _Glenn2.default, alt: 'Glenn @ fishfin', className: 'animated slideInLeft', style: {
	                            borderRadius: '50%',
	                            width: 200,
	                            height: 200,
	                            objectFit: 'cover',
	                            float: 'left',
	                            marginLeft: -20,
	                            marginRight: 20,
	                            boxShadow: '0px 7px 20px 0px #00000036'
	                        } }),
	                    _react2.default.createElement(
	                        'p',
	                        { style: { minWidth: 200 } },
	                        _react2.default.createElement(
	                            'em',
	                            { style: { fontSize: '1.2em', fontWeight: 800 } },
	                            'Fishfin'
	                        ),
	                        ' is a site dedicated to embracing the Floridian lifestyle. Our friends and family enjoy fishing in the Manatee River, Sarasota Bay and Tampa Bay on the southwest coast and Miami, Key Largo, Islamorada and the Bahamas on the east coast. Our other recreational activities include hunting hogs and scuba diving.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Before moving to Florida we fished for Striped Bass and dove in the cold waters of Massachusetts and New Jersey.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'This is our website, gallery, fishing log and links to some great guides and friends who enjoy similar interests her in the Sunshine State. A special thanks to \u201CJustin\u201D for creating this site for me allowing us to share our passion with you. Hope you like it.'
	                    ),
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { style: button, className: 'bounceClick', to: '/gallery/' },
	                        'Check Out Our Gallery',
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '\u27F6'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', marginTop: 20, width: '100%', overflowY: 'scroll' } },
	                        YouTubeIds.map(function (id) {
	                            return _react2.default.createElement('img', { onClick: function onClick() {
	                                    return _this3.setState({ YouTube: id });
	                                }, src: 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg', height: 150, style: { objectFit: 'cover', margin: 20 } });
	                        })
	                    )
	                )
	            )
	        );
	    };
	
	    return _class;
	}(_react2.default.Component);
	
	exports.default = _class;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-5b994a481539dfbc25a3.js